import React from "react";
import { GradientButton, Loader, Settings, Table } from "@housebets/housebets-x-package";

import { ChangePassword, EmailVerification, TwoAuthVerification } from "./cards";
import { useSecurityPanelData } from "./hooks/useSecurityPanelData";
import { useIntl } from "react-intl";

export const SecurityPanel: React.FC = (props) => {
    const { sessionData, cols, isLoading, onLoadMore, canLoadMore } = useSecurityPanelData();
    const {$t} = useIntl();

    return (
        <Settings.SecurityPanel.SPanel {...props}>
            <Settings.SecurityPanel.SList>
                <ChangePassword />

                <EmailVerification />

                <TwoAuthVerification />
            </Settings.SecurityPanel.SList>

            {/* <Settings.SecurityPanel.SRow>
                <Settings.LinkedAccounts
                    data={linkedAccountData}
                />
            </Settings.SecurityPanel.SRow> */}

            <Settings.SecurityPanel.SRow>
                <Settings.Sessions
                    table={
                        <>
                            <Table
                                data={sessionData}
                                column={cols}
                                v2
                                customControlledRowCount={{
                                    count: sessionData.length
                                }}
                                opacity="1"
                                autoHeight
                                autoHeightMax="100%"
                            />

                        </>
                    }
                    loadMore={
                        <>
                            {!isLoading && canLoadMore && (
                                <div
                                    style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <GradientButton
                                        text={$t({id: 'LoadMore'})}
                                        kind="fill"
                                        onClick={onLoadMore}
                                        disabled={!canLoadMore}
                                    />
                                </div>
                            )}
                            {isLoading && <Loader />}
                        </>
                    }
                />
            </Settings.SecurityPanel.SRow>

        </Settings.SecurityPanel.SPanel>
    )
}

SecurityPanel.displayName = 'SecurityPanel'